var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountCircleBlack24Dp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "account_circle_black_24dp",
    transform: "translate(-0.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2576",
    "data-name": "Group 2576"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6170",
    "data-name": "Rectangle 6170",
    width: 30,
    height: 30,
    transform: "translate(0.415)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2578",
    "data-name": "Group 2578",
    transform: "translate(2.5 2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2577",
    "data-name": "Group 2577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M14.5,2A12.5,12.5,0,1,0,27,14.5,12.5,12.5,0,0,0,14.5,2Zm0,22.5a9.926,9.926,0,0,1-5.812-1.875,9.947,9.947,0,0,1,11.625,0A9.926,9.926,0,0,1,14.5,24.5Zm7.675-3.6a12.439,12.439,0,0,0-15.35,0,10,10,0,1,1,15.35,0Z",
    transform: "translate(-2 -2)",
    fill: "#0d214b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M12.875,5.93a4.375,4.375,0,1,0,4.375,4.375A4.38,4.38,0,0,0,12.875,5.93Zm0,6.25a1.875,1.875,0,1,1,1.875-1.875A1.872,1.872,0,0,1,12.875,12.18Z",
    transform: "translate(-0.375 -1.018)",
    fill: "#0d214b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircleBlack24Dp);
export default __webpack_public_path__ + "static/media/account_circle_black_24dp.80469ab95d238804b2d29978f55071c0.svg";
export { ForwardRef as ReactComponent };